function FloppyIcon({
  width = 18,
  height = 18,
  fillColor = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0495 0C14.4835 0 14.8997 0.172399 15.2066 0.479283L17.5207 2.79344C17.8276 3.10033 18 3.51654 18 3.95053V15.5455C18 16.9011 16.9011 18 15.5455 18H2.45455C1.09894 18 0 16.9011 0 15.5455V2.45455C0 1.09894 1.09894 0 2.45455 0H14.0495ZM2.45455 1.63636C2.00268 1.63636 1.63636 2.00268 1.63636 2.45455V15.5455C1.63636 15.9973 2.00268 16.3636 2.45455 16.3636H3.27273V11.4545C3.27273 10.0989 4.37167 9 5.72727 9H12.2727C13.6284 9 14.7273 10.0989 14.7273 11.4545V16.3636H15.5455C15.9973 16.3636 16.3636 15.9973 16.3636 15.5455V4.76872C16.3636 4.33472 16.1912 3.91851 15.8843 3.61163L14.3884 2.11565C14.0815 1.80876 13.6653 1.63636 13.2313 1.63636H13.0909V3.27273C13.0909 4.62833 11.992 5.72727 10.6364 5.72727H7.36364C6.00803 5.72727 4.90909 4.62833 4.90909 3.27273V1.63636H2.45455ZM13.0909 16.3636V11.4545C13.0909 11.0027 12.7246 10.6364 12.2727 10.6364H5.72727C5.27541 10.6364 4.90909 11.0027 4.90909 11.4545V16.3636H13.0909ZM6.54545 1.63636H11.4545V3.27273C11.4545 3.72459 11.0882 4.09091 10.6364 4.09091H7.36364C6.91177 4.09091 6.54545 3.72459 6.54545 3.27273V1.63636Z"
        fill={fillColor} // Icon fill color
      />
    </svg>
  );
}

export default FloppyIcon;
